<template>
    <el-table
        :data="this.page.reminders"
        style="width: 100%">
        <el-table-column type="expand">
            <template slot-scope="props">
                <p>Fecha: {{ props.row.due_date }}</p>
                
            </template>
        </el-table-column>
        <el-table-column
            label="Título"
            prop="title+title">
        </el-table-column>
        <el-table-column
            label="Activo"
            prop="'-'">
        </el-table-column>
    </el-table>
</template>
<style lang="scss" scoped>
    .subtitle {
        color: #757575;
        padding-top:20px !important;
        text-align: left !important;
    }
</style>
<script>
import Vue from 'vue';
import { Message } from 'element-ui';
import ElementUI from 'element-ui';
import ElSelect from 'element-ui/lib/select';
import ElSwitch from 'element-ui/lib/switch';
import ElOption from 'element-ui/lib/option';
import ElDatePicker from 'element-ui/lib/date-picker';
import locale from 'element-ui/lib/locale/lang/es';

Vue.use(ElementUI, { locale });

export default {
    data: function(){
        return{
            tableData3: [{
                date: '2016-05-03',
                name: 'Tom',
                state: 'California',
                city: 'Los Angeles',
                address: 'No. 189, Grove St, Los Angeles',
                zip: 'CA 90036'
                }, {
                date: '2016-05-02',
                name: 'Tom',
                state: 'California',
                city: 'Los Angeles',
                address: 'No. 189, Grove St, Los Angeles',
                zip: 'CA 90036'
                }, {
                date: '2016-05-04',
                name: 'Tom',
                state: 'California',
                city: 'Los Angeles',
                address: 'No. 189, Grove St, Los Angeles',
                zip: 'CA 90036'
                }, {
                date: '2016-05-01',
                name: 'Tom',
                state: 'California',
                city: 'Los Angeles',
                address: 'No. 189, Grove St, Los Angeles',
                zip: 'CA 90036'
                }, {
                date: '2016-05-08',
                name: 'Tom',
                state: 'California',
                city: 'Los Angeles',
                address: 'No. 189, Grove St, Los Angeles',
                zip: 'CA 90036'
                }, {
                date: '2016-05-06',
                name: 'Tom',
                state: 'California',
                city: 'Los Angeles',
                address: 'No. 189, Grove St, Los Angeles',
                zip: 'CA 90036'
                }, {
                date: '2016-05-07',
                name: 'Tom',
                state: 'California',
                city: 'Los Angeles',
                address: 'No. 189, Grove St, Los Angeles',
                zip: 'CA 90036'
            }]
        }
    },
    components:{
        ElSelect,
        ElSwitch,
        ElOption,
        ElDatePicker
    },
    props: ['page'],
    computed: {
        validateForm: function() { 
            this.errors = {};
            var title = this.data.title === '' || this.data.title === null;
            var title_length = this.data.title > 255;
            var description = this.data.description === '' || this.data.description === null;
            var type = this.data.type === '' || this.data.type === null;
            var start_date = this.data.start_date > this.data.due_date;
            var init_date = this.data.init_date > this.data.exp_date;
            var errores = {};

            if(title){ errores["title"] = ["El campo Título no puede estar vacío."]; }
            if(title_length){ errores["title"] = ["El campo Título no puede exceder los 255 caracteres."]; }
            if(description){ errores["description"] = ["El campo Descripción no puede estar vacío."]; }
            if(type){ errores["type"] = ["El campo Tipo no puede estar vacío."]; }
            if(start_date){ errores["start_date"] = ["La fecha de inicio no puede ser mayor a la fecha de finalización."]; }
            if(init_date){ errores["init_date"] = ["La fecha de inicio no puede ser mayor a la fecha de finalización."]; }
            
            if (title || title_length || description || type || start_date || init_date){
                this.errors = errores;
                return true; 
            }else{
                return false;
            }
        }
    },
    methods:{
        validateType(){
            var self = this;
            if (this.data.type == 'unico'){
                self.mostrar_rango = false;
                self.data.start_date = self.data.due_date;
            }else{
                self.mostrar_rango = true;
            }
        },
        submit: function(){
            var self = this;
            if (self.validateForm){
                self.$message.error('Revise los errores en el formulario antes de continuar.');
            }else{
                if (self.edit){
                    var url_axios = 'backend/fichas/'+ self.page.id + '/reminders/' + self.data.id;
                    var method_axios = 'PUT';
                } else {
                    var url_axios = 'backend/fichas/'+ self.page.id + '/reminders/';
                    var method_axios = 'POST';
                }
                axios({
                    url: url_axios,
                    method: method_axios,
                    data: self.data,
                }).then(function(response){
                    window.location.replace(response.data.redirect);
                }).catch(function(error){
                    self.errors = error.response.data.errors;
                });
            }
        }
    },
    mounted: function(){
        //this.validateType();
    }
}
</script>